<template>
  <div>
    <div class="scrollCardKontaktAnfahrt-1 scrollContentLastDIV">
      <div class="container">
        <div class="scrollContentTitle">
          <h6 class="title title-up text-center navHeadline">Kontakt & Anfahrt</h6>
          <h4 class="text-center title navHeadlineText">Erfahren Sie, wann und wo Sie mich finden können</h4>
        </div>

        <div class="row">
          <div class="col-lg-6">


            <blockquote>
              <p class="blockquote text-center">
                <iframe async defer src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2429.0053220641976!2d10.759111316001123!3d52.49714324567502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47af95212cf7c8fd%3A0x5f5c7f7bccb6a9d!2sAnja&#39;s%20Fu%C3%9Fpflege!5e0!3m2!1sde!2sde!4v1597179658702!5m2!1sde!2sde" width="100%" height="350px" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                <span class="title">Fußpflege Anja Bender</span>
                <br>
                Hauptstraße 38A
                <br>
                38477 Jembke
                <br>
                Telefon: 01XX XXXXXX
                <br>
                <br>
                <b style="font-style: oblique">Parken können Sie auf dem Edeka Parkplatz</b>
              </p>
            </blockquote>
          </div>

          <div class="col-lg-6">
            <h4 class="title navHeadlineContent">Hinweis</h4>
            <p class="text text-justify">
              Sie und Ihre gewünschte Behandlung stehen bei mir im Mittelpunkt. Das bedeutet, dass ich eine laufende Behandlung nicht für Telefonate, etc. unterbreche, sondern meine gesamte Aufmerksamkeit Ihnen gilt.
              <br>
              Daher bitte ich Sie, für Terminvereinbarungen eine Nachricht auf meinem Anrufbeantworter zu hinterlassen. Ich werde Sie schnellstmöglich zurückrufen.
              <br>
              Vielen Dank für Ihr Verständnis.
            </p>

            <h4 class="title navHeadlineContent">Abwesenheiten</h4>
            <p class="text text-justify">
              Ich habe folgende geplante Abwesenheiten:<br>
              21.12.2020 - 04.01.2021
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: "KontaktAnfahrt",
    }
</script>

<style scoped>

</style>